import React from 'react';
import PropTypes from 'prop-types';
import { containerConnect } from '@configuratorware/configurator-frontendgui/Framework/ComponentContainer';
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import {
  getSelectedDesignAreaProperties,
  getDesignDataForFilteredDesignAreas,
} from '@configuratorware/configurator-frontendgui/App/Reducers/DesignArea/Selectors';
import { setDesignerMobileProductListOpen, setDesignerMobileModalContent } from '../../../Reducers/CustomDesignReducer/Actions';
import MobilePickerMenu from '../Components/MobilePickerMenu';

const MobilePickerMenuContainer = (props) => (
  <>
    <MobilePickerMenu
      {...props}
    />
  </>
);
MobilePickerMenuContainer.propTypes = {
  deselectImage: PropTypes.func,
  imageGallery: PropTypes.object,
  canvas: PropTypes.object,
  selectedObject: PropTypes.object,
  AddVisualElementComponent: PropTypes.func,
  loading: PropTypes.bool,
  autoHide: PropTypes.bool,
  hasLastEditedDesignArea: PropTypes.bool,
};

MobilePickerMenuContainer.defaultProps = {
  autoHide: false,
};
const mapStateToProps = (state) => {
  const {
    filteredDesignAreas,
    designProductionMethod,
    selectedDesignArea,
  } = getSelectedDesignAreaProperties(state);
  const hasDesign = getDesignDataForFilteredDesignAreas(state);

  return ({
    Component: MobilePickerMenuContainer,
    filteredDesignAreas,
    designProductionMethod,
    selectedDesignArea: selectedDesignArea || null,
    selectedoptionclassification: state.configurator.selectedoptionclassification,

    designedAreas: hasDesign || {},
    optionclassifications: state.configurator.filteredOptionclassifications,
    loading: state.ui.visibilityMap.loadVisualization,
    doDisplay: /* isMobileDevice() && */ state.customDesignerData.designerMobileProductsListOpen,
    handleChangeProductionMethod: ({ target: { value } }) => {
      Services.designData.setDesignProductionMethod(value);
      Services.configurator.resolveCalculationErrors();
    },
    handleChangeDesignArea: (value) => Services.designData.selectDesignArea(value),
    openDesignArea: () => Services.designData.openDesignAreaEditor(),
    closeDesignArea: () => Services.designData.clearDesignAreaSelection(),
    modalContentOptions: state.customDesignerData.designerMobileModalContentOptions,
    currentModalContentOption: state.customDesignerData.designerMobileModalContent,
  });
};

const mapDispatchToProps = (dispatch) => ({
  closeMobilePickerMenu: () => { dispatch(setDesignerMobileProductListOpen(false)); },
  setModalContentOption: (value) => {
    dispatch(setDesignerMobileModalContent(value));
  },
});
export default containerConnect(mapStateToProps, mapDispatchToProps);
